import router from '@/router/index'

export default {
  SET_ORGANISATION_NAME(state, payload) {
    state.response.organisationName = payload.name
    state.errors.getName = ''
    state.loading.innOrganisation = false
  },
  SET_PERSONAL_NAME(state, payload) {
    state.response.personalName = payload.name
    state.errors.getName = ''
    state.loading.innPersonal = false
  },
  GET_NAME_ERROR(state, error) {
    state.errors.getName = error
  },
  SET_LOADING(state, payload) {
    payload.type === 'organisation'
      ? (state.loading.innOrganisation = payload.val)
      : (state.loading.innPersonal = payload.val)
  },
  CLEAR_NAMES(state, payload) {
    payload.type === 'organisation' ? (state.response.organisationName = '') : (state.response.personalName = '')
  },
  CHECK_INN_SUCCESS(state, payload) {
    state.response.infoInn = payload
    state.errors.getName = ''
    state.errors.checkInn = ''
    state.loading.checkInn = false
    state.nextStep = payload.next
  },
  CHECK_INN_ERROR(state, error) {
    state.errors.checkInn = error
    state.loading.checkInn = false
  },
  CHECK_INN_LOADING(state, payload) {
    state.loading.checkInn = payload
  },
  CHECK_PIN_CODE_SUCCESS(state, payload) {
    state.response.pinConfirmInfo = payload
    state.errors.checkPin = ''
    state.loading.checkPin = false
    sessionStorage.setItem('token', payload.sessionId)
    state.response.organisationName = ''
    state.response.personalName = ''
    state.response.infoInn = {}
    state.nextStep = ''
  },
  CHECK_PIN_CODE_ERROR(state, error) {
    state.errors.checkPin = error
    state.loading.checkPin = false
  },
  CHECK_PIN_LOADING(state, payload) {
    state.loading.checkPin = payload
  },
  LOGOUT() {
    sessionStorage.clear()
    router.push({ path: '/' })
  }
}
